module.exports = __webpack_public_path__ + "static/logo-8be9f6162fffd7dbfe0ab9658e580549.png";